import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { WrapperBlock } from 'coreOld/elements';

interface WrapperProps {
  flex?: string | number;
  height?: number;
  children?: ReactNode;
  noContent?: boolean;
}

export const Wrapper = styled(WrapperBlock)<WrapperProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 15px;
  border-bottom: none;
  border-right: ${({ theme }) => `1px solid ${theme.palette.text.secondary}`};

  ${({ flex }) =>
    flex &&
    css`
      flex: ${flex};
    `}
  ${({ height }) =>
    height &&
    css`
      height: ${height}px;
    `}
`;

interface WrapTopProps {
  children?: ReactNode;
}

export const WrapTop = styled.div<WrapTopProps>`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

interface CloseButtonProps {
  children?: ReactNode;
  onClick?: any;
  type?: string;
}

export const CloseButton = styled.button<CloseButtonProps>`
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  color: #555;
  border: none;
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }
`;

interface TitleModalProps {
  children?: ReactNode;
}

export const TitleModal = styled.h2<TitleModalProps>`
  color: ${({ theme }) => theme.palette.neutral.dark};
  font:
    600 18px 'Open Sans',
    sans-serif;
  letter-spacing: -0.0278em;
  margin: 6px 0 3px;
`;

interface SubtitleModalProps {
  children?: ReactNode;
}

export const SubtitleModal = styled.span<SubtitleModalProps>`
  font-weight: 400;
  color: ${({ theme }) => theme.palette.neutral.dark};
`;
